import { ActionBase } from '../../../core/store/action/ActionBase';
import { ExtractModel } from "../../models/ExtractModel";

export const FINALIZE_EXTRACT = '[Extract] Finalize Extract';

export class FinalizeExtractAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = FINALIZE_EXTRACT;

  constructor(public payload: { extractKey: string, model: ExtractModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/FinalizeExtractAction.ts